import { Box, Typography } from "@mui/material";
import { useRTL } from "hooks/isRTL";
import DriverDetailsTabs from "./DriverManagementTaps/DriverDetailsTabs";
import BackButton from "Components/shared/BackButton";

const DriverDetails = () => {
  const { t } = useRTL();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem 4rem",
      }}
    >
      <BackButton text={t("back")} />
      <Typography variant="h3">{t("driverDetails")}</Typography>
      <DriverDetailsTabs />
    </Box>
  );
};
//backToDriverRequests

export default DriverDetails;
